// extracted by mini-css-extract-plugin
export var container = "PromoGrid-module--container--2vYNL";
export var containerRight = "PromoGrid-module--containerRight--2mgkT";
export var big = "PromoGrid-module--big--3BHz6";
export var small = "PromoGrid-module--small--WOvT-";